module.exports = new __parcel__URL__("microsoftTeams.9706d9b4.png").toString();